<template>
  <div class="col-md-8 m-auto">
    <v-card>
      <v-card-text>
        <p>
          <b>Предлагаме следните методи на плащане:</b>
        </p>

        <ul>
          <li>PayPal</li>
          <li>Плащане с дебитна или кредитна банкова карта.</li>
          <li>Плащане в брой на каса на EasyPay</li>
          <li>
            Плащане чрез микросметка в еPay и на банкомат чрез системата на
            Борика
          </li>
        </ul>

        <p>
          <b>Сайтът поддържа следните карти:</b>
        </p>
        <img
          class="max-height"
          src="/img/cards.jpg"
          alt=""
        />
        <br />
        <br />

        <p>
          <b>
            Картовите плащания се осигуряват чрез следните системи за сигурност:
          </b>
        </p>
        <img
          class="max-height"
          src="/img/visa-mastercard.gif"
          alt=""
        />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  mixins: [],
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
}
</script>

<style>
ul {
  list-style: none;
}

ul li {
  font-weight: bold;
}

.max-height {
  max-height: 40px;
}
</style>
